import { inject, Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';

/**
 * Título da aba do navegador: "Hoje · ObraSync".
 *
 * Rota sem título mantém o do index.html (a landing). Título que já cita o
 * ObraSync fica como está.
 */
@Injectable({ providedIn: 'root' })
export class PageTitleStrategy extends TitleStrategy {
	private readonly title = inject(Title);

	override updateTitle(snapshot: RouterStateSnapshot): void {
		const title = this.buildTitle(snapshot);
		if (!title) return;
		this.title.setTitle(title.includes('ObraSync') ? title : `${title} · ObraSync`);
	}
}
